import React, { useEffect, useState } from 'react';
import {
  SelectionCells,
  SelectionCell,
  SelectionEdit,
  SelectionSaveBtn,
  SelectionItemRemove,
  ProductImagePlaceholder,
  StandaloneCharCount,
  GFPackingInfo,
} from '../styles';
import { MobileSelectionItemRemove } from '../styles/MobileStyles';
import Shuffle from './common/Shuffle';
import Misc from './common/Misc.svg';
import AddMessage from './common/AddMessage';
import BuyBtn from './BuyBtn';
import BoxSizeSelector from './common/BoxSizeSelector';
import PersonalisationInput from './PersonalisationInput';
import SingleMsgPrompt from './common/SingleMsgPrompt';
import SelectionItem from './SelectionItem';

const SelectionItems = ({
  limit,
  selection,
  sizes,
  handleLimitChange,
  clearSelection,
  updateItemRemove,
  randomise,
  handleShowMessages,
  currentRange,
  isMobile,
  charLimit,
  handleAddMessage,
  firstMsg,
  setFirstMsg,
  handleSingleMessage,
  singleMessage,
  setSingleMessage,
  presetMsg,
  setPresetMsg,
  setSelection,
  clearMultiMessage,
  getCharacterCount,
  editable,
  personalisationSelected,
  setPersonalisationSelected,
  setEditable,
  isMini,
}) => {

  const [focusedProduct, setFocusedProduct] = useState(null);
  const [mixedGF, setMixedGf] = useState(false);

  useEffect(() => {

    // * check if focused product is part of new selection

    const switchFocusedProduct = () => {
      const fpSelected = selection.find(
        (item) => item?.bId === focusedProduct.bId
      );
      if (!fpSelected) {
        // * check for first product with message ? make it focused : set to null
        const firstMessageProduct = selection.find((item) => item?.message);

        firstMessageProduct
          ? setFocusedProduct(firstMessageProduct)
          : setFocusedProduct(null);
      }
    };

    const findMixedSelection = () => {
      const nGF = selection.find(
        (item) => !item?.title.toLowerCase().includes('gluten freee')
      );
      const gF = selection.find((item) =>
        item?.title.toLowerCase().includes('gluten free')
      );
      return gF && nGF ? true : false;
    };

    if (findMixedSelection()) {
      !mixedGF ? setMixedGf(true) : null;
    } else {
      mixedGF ? setMixedGf(false) : null;
    }

    focusedProduct && selection.some((item) => item !== null)
      ? switchFocusedProduct()
      : null;
  }, [selection]);

  useEffect(() => {
    console.log('focused product changed: ', focusedProduct)
  },[focusedProduct])

  return (
    <>
      <div className="scroll-inner">
        <div className="d-flex justify-content-between align-items-center">
          {!isMobile && (
            <SelectionEdit
              className="text-capitalize"
              onClick={clearSelection}
              $rightAlign
            >
              Clear Your Box
            </SelectionEdit>
          )}
          {focusedProduct &&
            personalisationSelected &&
            selection.find(
              (item) => item !== null && item?.bId === focusedProduct.bId
            ) && (
              <StandaloneCharCount>
                Characters remaining:{' '}
                <span>
                  {getCharacterCount(
                    selection.find((item) => item?.bId === focusedProduct.bId)
                  )}
                </span>
              </StandaloneCharCount>
            )}
        </div>

        <SelectionCells>
          {selection.map((selectionItem, i) => {
            return (
              <SelectionItem
                key={i + 10}
                currentIndex={i}
                selectionItem={selectionItem}
                focusedProduct={focusedProduct}
                singleMessage={singleMessage}
                editable={editable}
                personalisationSelected={personalisationSelected}
                isMobile={isMobile}
                handleAddMessage={handleAddMessage}
                firstMsg={firstMsg}
                setFirstMsg={setFirstMsg}
                handleSingleMessage={handleSingleMessage}
                setSingleMessage={setSingleMessage}
                presetMsg={presetMsg}
                setPresetMsg={setPresetMsg}
                selection={selection}
                setFocusedProduct={setFocusedProduct}
                getCharacterCount={getCharacterCount}
                updateItemRemove={updateItemRemove}
              />
            );
          })}
        </SelectionCells>
        {!isMobile &&
          ((personalisationSelected &&
            selection.find(
              (item) =>
                item?.message &&
                selection.filter(
                  (item) => item?.personalisation_available === 'Y'
                ).length >= 1
            )) ||
            (personalisationSelected &&
              selection.filter(
                (item) => item?.personalisation_available === 'Y'
              ).length > 1 &&
              singleMessage)) && (
            <>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <SingleMsgPrompt
                  focusedProduct={focusedProduct}
                  singleMessage={singleMessage}
                  setSingleMessage={setSingleMessage}
                  handleSingleMessage={handleSingleMessage}
                  selection={selection}
                  firstMsg={firstMsg}
                  isMobile={isMobile}
                />
                <SelectionEdit onClick={() => clearMultiMessage()} $rightAlign>
                  clear all messages
                </SelectionEdit>
              </div>
            </>
          )}
        <AddMessage
          setPersonalisationSelected={setPersonalisationSelected}
          personalisationSelected={personalisationSelected}
          editable={editable}
          selection={selection}
          charLimit={charLimit}
          setSelection={setSelection}
          clearMultiMessage={clearMultiMessage}
          focusedProduct={focusedProduct}
          setFocusedProduct={setFocusedProduct}
          singleMessage={singleMessage}
          setSingleMessage={setSingleMessage}
          isMobile={isMobile}
          isMini={currentRange.bundle_name === 'MINI_OBJ'}
        />
        {!!mixedGF && (
          <GFPackingInfo>
            <h6 className="tt-title">
              Gluten Free cupcakes will be packed separately!
            </h6>
            <p>
             To avoid cross-contamination, we do not allow Gluten Free items to be packed with non Gluten Free items. If choosing postal delivery, we will send a separate box.
            </p>
          </GFPackingInfo>
        )}
        {!editable ? (
          <BuyBtn
            selectionStage="review"
            personalisationSelected={personalisationSelected}
            selection={selection}
            limit={limit}
            products={currentRange}
            handleShowMessages={handleShowMessages}
            isMobile={isMobile}
            isMini={isMini}
          />
        ) : (
          <div className="row justify-content-between">
            <SelectionSaveBtn onClick={() => setEditable(false)}>
              Save
            </SelectionSaveBtn>
            <Shuffle edit={true} randomise={randomise} />
          </div>
        )}
      </div>
    </>
  );
};

export default SelectionItems;
